// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1QATr","footer":"Form_footer__cyyFu"};